import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import ReactToPrint from "react-to-print";

import AllReportCardsHistory from "./AllReportCardsHistory";
import "./PrintStudentResults.css";
import useAcademicYearOptions from "../utils/useAcademicYearOptions";

function PrintAllStudentReportCards(props) {
  const [currentAcademicYear] = useAcademicYearOptions({ previousYears: 0 });
  const {
    individualStudentResult,
    assessmentResultsByStudent,
    student,
    classDetails,
    detailedView,
    buttonName,
    studentResults,
    students,
    schoolid,
    teacherid,
    teachers,
    toggleScoreType,
    hideAccordion,
  } = props;

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.toLocaleString("default", { month: "long" });
  const currentYear = currentDate.getFullYear();

  const componentRef = useRef();

  return (
    <>
      <StudentPrintable
        individualStudentResult={individualStudentResult}
        assessmentResultsByStudent={assessmentResultsByStudent}
        student={student}
        classDetails={classDetails}
        currentDay={currentDay}
        currentMonth={currentMonth}
        currentYear={currentYear}
        detailedView={detailedView}
        ref={componentRef}
        studentResults={studentResults}
        toggleScoreType={toggleScoreType}
        hideAccordion={hideAccordion}
        isPrintOut={true}
        teacherid={teacherid}
        schoolid={schoolid}
        teachers={teachers}
        students={students}
        academicYear={currentAcademicYear.display}
      />

      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => (
          <button className="blue-button" style={{ borderRadius: "8px" }}>
            Print All Report Cards
          </button>
        )}
      />
    </>
  );
}

const StudentPrintable = React.forwardRef((props, componentRef) => {
  return (
    <div
      className="hide-div landscape-print"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <div ref={componentRef}>
        {/* Print-only header */}
        <div className="alpaca-print-header">
          <div className="printout-logo" />
          <div className="alpaca-print-header-text">
            <span className="alpaca-print-header-class">
              {props.classDetails?.name || "Class Name"}
            </span>
            <span className="alpaca-print-header-year">
              School Year: {props.academicYear}
            </span>
          </div>
        </div>
        <Row>
          <Col className="printout-logo col-2"></Col>
          <Col className="col-5">
            <h3 className="printout-page-description-header">Report Cards</h3>
          </Col>
          <Col className="col-5">
            <h3 className="printout-page-description-header">
              {props.classDetails.name}
            </h3>
          </Col>
        </Row>
        <Row>
          <AllReportCardsHistory
            studentResults={props.studentResults}
            toggleScoreType={props.toggleScoreType}
            assessmentResultsByStudent={props.assessmentResultsByStudent}
            teacherid={props.teacherid}
            schoolid={props.schoolid}
            teachers={props.teachers}
            students={props.students}
            hideAccordion={props.hideAccordion}
          />
        </Row>
      </div>
      {/* <div
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          textAlign: "center",
          fontSize: "0.9rem",
          color: "#888",
          padding: "8px 0",
          background: "white",
          zIndex: 1000,
        }}
      >
        Powered by ALPACA &copy; {new Date().getFullYear()}
      </div> */}
    </div>
  );
});

export default PrintAllStudentReportCards;
